import api from "./axios";
import { ModuloInfo, OpenApiDoc } from "../pages/admin/apiDocs/openapi";

const BASE = "/docs/modulos";

/** Módulos de API visíveis para quem chama (uma chave restrita só vê os módulos dela). */
export async function getModulosApi(): Promise<ModuloInfo[]> {
  const { data } = await api.get(BASE);
  return Array.isArray(data) ? data : [];
}

/** Documento OpenAPI 3 do módulo. */
export async function getDocumentoModulo(id: string): Promise<OpenApiDoc> {
  const { data } = await api.get(`${BASE}/${encodeURIComponent(id)}`);
  return typeof data === "string" ? JSON.parse(data) : data;
}
